/**
 * Messenger Functions
 */
import { environment } from "root/environments/environment";
import { MessengerParams } from "types/remote/messenger_params";

function sendParametersToParent(params: MessengerParams): void {
  const url: string[] = document.referrer.split("/");
  const months: string =
    params.deferredOptions !== undefined ? params.deferredOptions.months : "";
  const type: string =
    params.deferredOptions !== undefined ? params.deferredOptions.type : "";
  // istanbul ignore next
  const monthsOfGrace: string =
    params.deferredOptions !== undefined &&
    params.deferredOptions.monthsOfGrace !== undefined
      ? params.deferredOptions.monthsOfGrace
      : "";

  if (environment.env === "dev") return;

  window.parent.postMessage(
    `parameters:${params.token},${months},${
      params.paymentMethod
    },${type},${monthsOfGrace}`,
    `${url[0]}//${url[2]}`
  );
}

// istanbul ignore next
function sendHeight(height: number): void {
  const url: string[] = document.referrer.split("/");

  if (environment.env === "dev") return;

  window.parent.postMessage(`height:${height}`, `${url[0]}//${url[2]}`);
}

export { sendParametersToParent, sendHeight };



// WEBPACK FOOTER //
// ./src/shared/Messenger.tsx